export enum WallpaperCategory {
  CUSTOM = 'custom',
  CURATED = 'curated',
  BRANDED = 'branded',
}
